<template>
  <article class="modal_devices">
    <section class="modal_devices__modal">
      <div class="modal_devices__modal__info">
        <img @click="onCancelModal" src ="./../../assets/img/icons/close.svg" class="x_button">
        <h5>Seleccione una o varias empresas</h5>
        
      </div>
      <div :style ="{margin:'20px', 'border-bottom':'1px solid #E2E7ED'}" class="search_input">
        <input  type="text" id="myInput" v-on:keyup ="search" placeholder="Buscar...">
        <img  src="./../../assets/img/icons/search.svg">
      </div>
      <div class="modal_devices__modal__device-list">
        <table class="simple_table" id="myTable">
          <tr v-for="(item,i) in devices" :key=i>
            <td>
                <input type="checkbox" :value="item.id" v-model="contracts" v-if="typeSelection == 'multiple'">
                <input type="radio" :value="item.id" v-model="contract" v-if="typeSelection == 'single'">
            </td>
            <td>
              <div>{{item.name}}</div>
            </td>
            <td>
              <div >{{item.nit}}</div>
            </td>
          </tr>
        </table>
      </div>
      <button class="primary_button" style="width: 100%; height: 46px;" @click="onSelectModal">ACEPTAR</button>
    </section>
  </article>
</template>

<script>
export default {
  props: {
    companies: {
      type: Array
    },
    company: {
      type: Object
    },
    typeSelection: {
      type: String,
      required: true
    }
  },
  data(){
    return{
      devices:[],
      contracts:[],
      contract: null,
    }
  },
  methods:{
    onCancelModal(event){
      this.$emit('cancel', false);
    },
    onSelectModal(){

      switch (this.typeSelection) {
        case 'multiple':
          const Empresas = [];
          this.devices.forEach(device => {
            this.contracts.forEach(contract => {
              if (device.id == contract) {
                Empresas.push({
                  id: device.id,
                  name: device.name
                })
              }
            });
          });
          this.$emit('select', Empresas);
          break;
        case 'single':
          this.devices.forEach(device => {
            if (device.id == this.contract) {
              this.$emit('select', {
                id: device.id,
                name: device.name,
                nit: device.nit
              });
            }
          });
          break;
      }
      
    },
    search(){
      // Declare variables 
      var input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toUpperCase();
      table = document.getElementById("myTable");
      tr = table.getElementsByTagName("tr");

      // Loop through all table rows, and hide those who don't match the search query
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      
      }
    },
  },
  created(){
    
    const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    };
    this.$resource('company',{},customActions).get({"id_card":JSON.parse(localStorage.getItem('user')).id_card})
    .then(function(data){
      this.devices=data.body;
    }).catch(function(err){
      console.log('ERROR')
      console.log(err)
    });

    this.typeSelection == 'multiple' ? this.contracts = this.companies : this.contract = this.company.id;
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/ModalDevices.vue